import http from '@/api/base'

const queryRentalUserList = params => {
  return http.post('/portal/apartment/lock/fingerprint/queryRentalUserList', params)
}
const addRoomLockUser = params => {
  return http.post('/portal/apartment/lock/fingerprint/addOrUpdateRoomLockUser', params)
}
const setEnableRentalUser = params => {
  return http.post('/portal/apartment/lock/fingerprint/setEnableRentalUser', params)
}
// 门卡列表
const nfcList = params => {
  return http.post('/portal/apartment/nfc/list', params)
}
// 门卡详情
const nfcDetail = params => {
  return http.get('/portal/apartment/nfc/detail', {params})
}
// 门卡启用
const nfcEnable = params => {
  return http.post('/portal/apartment/nfc/enable', params)
}
// 门卡禁用
const nfcDisabl = params => {
  return http.post('/portal/apartment/nfc/disable', params)
}
// 门卡回收
const nfcRevoke = params => {
  return http.post('/portal/apartment/nfc/revoke', params)
}
// 门卡保存
const nfcSave = params => {
  return http.post('/portal/apartment/nfc/save', params)
}
// 超管密码
const passwordAdminList = params => {
  return http.get('/portal/apartment/password/adminList', { params })
}
// 超管密码(修改密码)
const passwordChangeAdmin = params => {
  return http.post('/portal/apartment/password/changeAdmin', params)
}
// 密码管理 房间列表
const passwordRoomList = params => {
  return http.post('/portal/apartment/password/roomList', params)
}
// 密码管理 房间详情
const passwordRoomDetail = params => {
  return http.get('/portal/apartment/password/roomDetail', { params })
}
// 密码管理 重置密码
const passwordResetPassword = params => {
  return http.post('/portal/apartment/password/resetPassword', params)
}
// 密码管理 解除授权
const passwordRevokePassword = params => {
  return http.post('/portal/apartment/password/revokePassword', params)
}

// 密码授权 列表
const passwordAuthList = params => {
  return http.post('/portal/apartment/password/authList', params)
}
// 密码授权 列表 详情
const passwordAuthDetail = params => {
  return http.get('/portal/apartment/password/authDetail', { params })
}
// 密码授权 授权
const passwordAuth = params => {
  return http.post('/portal/apartment/password/auth', params)
}
// 密码授权 取消授权
const passwordRevokeAuth = params => {
  return http.post('/portal/apartment/password/revokeAuth', params)
}
// 锁信息
const lockMessageList = params => {
  return http.post('/portal/apartment/lock/messageList', params)
}
export default {
  queryRentalUserList,
  addRoomLockUser,
  nfcList,
  nfcDetail,
  nfcEnable,
  nfcDisabl,
  nfcRevoke,
  nfcSave,
  setEnableRentalUser,
  passwordAdminList,
  passwordChangeAdmin,
  passwordRoomList,
  passwordRoomDetail,
  passwordResetPassword,
  passwordRevokePassword,
  passwordAuthList,
  passwordAuthDetail,
  passwordAuth,
  passwordRevokeAuth,
  lockMessageList
}



// WEBPACK FOOTER //
// ./src/area-apartment/api/impowerService.js